import { useAppSelector } from './useAppSelector'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
import timezone from 'dayjs/plugin/timezone'

dayjs.extend(utc)
dayjs.extend(timezone)

export const useTimezone = () => {
    const t = useAppSelector(state => state.userPreference.data.timezone)

    const getTimezone = (t: string | undefined) => {
        if(!t) {
            return Intl.DateTimeFormat().resolvedOptions().timeZone
        }

        if(t[0] === '-' || t[0] === '+') {
            const [_, tz] = t.split(' ')
            return tz
        }

        return t
    }

    const timezone = getTimezone(t?.val)

    const formatUtcTimeFromLocal = (
        date: string | Date | null,
        format = 'YYYY/MM/D HH:mm:ss' //default for API
    ): string | null => {
        if(!date) return null

        try {
            return dayjs.tz(date, timezone).utc().format(format)
        } catch(e) {
            console.error(`String incorrectly formatted ${date}`, e)
            return null
        }        
    }

    const formatLocalTimeFromUtc = (
        date: string | Date | null,
        format = 'YYYY-MM-DD HH:mm:ss' //default for display
    ): string | null => {
        if(!date) return null

        try {
            const isoDate = dayjs.utc(date, "YYYY-MM-DDTHH:mm:ssZ")
            if(isoDate.isValid()) {
                return isoDate.tz(timezone).format(format)
            }

            return dayjs.utc(date).tz(timezone).format(format)
        } catch(e) {
            console.error(`String incorrectly formatted ${date}`, e)
            return null
        }        
    }

    return { timezone, formatUtcTimeFromLocal, formatLocalTimeFromUtc }
}